import { Check, MapPin } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { FestiveBadge } from "@/components/tss/FestiveBadge";

const initials = (name) =>
  name.replace(/[[\]]/g, "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

export const Thumb = ({ committee, size = "h-12 w-12" }) =>
  committee.photo_url ? (
    <img src={mediaUrl(committee.photo_url)} alt="" className={`${size} shrink-0 rounded-lg object-cover`} loading="lazy" />
  ) : (
    <span className={`${size} grid shrink-0 place-items-center rounded-lg bg-gradient-to-br from-maroon to-maroon-deep font-display text-base font-bold text-gold-light`}>
      {initials(committee.name)}
    </span>
  );

export const CommitteeCard = ({ committee, selected, onSelect, testId, badgeIndex = 0 }) => (
  <button
    type="button"
    onClick={onSelect}
    data-testid={testId}
    aria-pressed={selected}
    className={`flex w-full items-center gap-3 rounded-xl border p-2.5 pr-3 text-left transition-[background-color,border-color,transform,box-shadow] duration-200 active:scale-[0.98] ${
      selected ? "border-maroon bg-maroon text-ivory shadow-festive" : "border-gold/30 bg-white hover:border-gold"
    }`}
  >
    {committee.photo_url ? <Thumb committee={committee} /> : <FestiveBadge index={badgeIndex} />}
    <span className="min-w-0 flex-1">
      <span className="line-clamp-2 block text-[15px] font-semibold leading-snug">{committee.name}</span>
      {committee.area && (
        <span className={`mt-0.5 flex items-center gap-1 truncate text-xs ${selected ? "text-ivory/75" : "text-ink-muted"}`}>
          <MapPin className="h-3 w-3 shrink-0" />
          {committee.area}
        </span>
      )}
    </span>
    <span
      className={`grid h-6 w-6 shrink-0 place-items-center rounded-full border-2 ${
        selected ? "pop border-gold bg-gold text-maroon-deep" : "border-gold/50"
      }`}
    >
      {selected && <Check className="h-3.5 w-3.5" strokeWidth={3} />}
    </span>
  </button>
);
